_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[55],{

/***/ "3f9c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");

// EXTERNAL MODULE: ./data/shops.js
var shops = __webpack_require__("z1id");
var shops_default = /*#__PURE__*/__webpack_require__.n(shops);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./actionTypes/index.js
var actionTypes = __webpack_require__("ifZB");

// CONCATENATED MODULE: ./actions/addDynamicVariants.ts


var addDynamicVariants_addDynamicVariants = function addDynamicVariants(dynamicVariants, dynamicVariantIds) {
  return {
    type: actionTypes["b" /* ADD_DYNAMIC_VARIANTS */],
    payload: {
      dynamicVariants: dynamicVariants,
      dynamicVariantIds: dynamicVariantIds
    }
  };
};

/* harmony default export */ var actions_addDynamicVariants = (addDynamicVariants_addDynamicVariants);
// CONCATENATED MODULE: ./utils/fetchShopifyDynamicVariants.ts



/**
 * The structure of the variants returned from the shopify api
 */
var fetchShopifyDynamicVariants = /*#__PURE__*/function () {
  var _ref = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(variantIds, shop) {
    var apiUrl, query, response, json, normalizedDynamicVariants;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apiUrl = "https://".concat(shop.domain, "/api/2021-01/graphql.json");
            query = makeQuery(variantIds);
            _context.next = 4;
            return fetch(apiUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Shopify-Storefront-Access-Token': shop.storefrontAccessToken
              },
              body: JSON.stringify({
                query: query
              })
            });

          case 4:
            response = _context.sent;
            _context.next = 7;
            return response.json();

          case 7:
            json = _context.sent;
            normalizedDynamicVariants = json.data.nodes.map(function (apiVariant) {
              var _apiVariant$compareAt;

              var dynamicVariant = {
                id: apiVariant.id,
                price: apiVariant.priceV2.amount,
                available: apiVariant.availableForSale,
                compareAtPrice: (_apiVariant$compareAt = apiVariant.compareAtPriceV2) === null || _apiVariant$compareAt === void 0 ? void 0 : _apiVariant$compareAt.amount
              };
              return dynamicVariant;
            });
            return _context.abrupt("return", normalizedDynamicVariants);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchShopifyDynamicVariants(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var makeQuery = function makeQuery(variantIds) {
  return "\nquery {\n  nodes(ids: ".concat(JSON.stringify(variantIds), ") {\n    ... on ProductVariant {\n      id\n      availableForSale\n      compareAtPriceV2 {\n        amount\n      }\n      priceV2 {\n        amount\n        currencyCode\n      }\n    }\n  }\n}\n");
};

/* harmony default export */ var utils_fetchShopifyDynamicVariants = (fetchShopifyDynamicVariants);
// CONCATENATED MODULE: ./utils/hooks/useGetDynamicVariants.ts




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var useGetDynamicVariants_useGetDynamicVariants = function useGetDynamicVariants(variantIds, shopId) {
  var dispatch = Object(es["c" /* useDispatch */])();

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.entities;
  }),
      dynamicVariants = _useSelector.dynamicVariants,
      products = _useSelector.products,
      variants = _useSelector.variants; // Only search for missing variant int the currently selected shop


  var currentShopVariantIds = variantIds.filter(function (variantId) {
    var _products$byId$varian, _variants$byId$varian;

    return ((_products$byId$varian = products.byId[(_variants$byId$varian = variants.byId[variantId]) === null || _variants$byId$varian === void 0 ? void 0 : _variants$byId$varian.productId]) === null || _products$byId$varian === void 0 ? void 0 : _products$byId$varian.shopId) === shopId;
  });
  Object(react["useEffect"])(function () {
    function fetchVariants() {
      return _fetchVariants.apply(this, arguments);
    }

    function _fetchVariants() {
      _fetchVariants = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var missingIds, fetchedDynamicVariants, dynamicVariantsById, dynamicVariantIds;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Filter out the variantIds that are not already in the cache and only fetch those
                missingIds = currentShopVariantIds.filter(function (variantId) {
                  var _dynamicVariants$byId;

                  return !((_dynamicVariants$byId = dynamicVariants.byId) === null || _dynamicVariants$byId === void 0 ? void 0 : _dynamicVariants$byId[variantId]);
                }); // If all the variantIds are already in the cache, return;

                if (missingIds.length) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _context.next = 5;
                return utils_fetchShopifyDynamicVariants(missingIds, shops_default.a.byId[shopId]);

              case 5:
                fetchedDynamicVariants = _context.sent;
                dynamicVariantsById = fetchedDynamicVariants.reduce(function (acc, variant) {
                  return _objectSpread(_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, variant.id, variant));
                }, {});
                dynamicVariantIds = Object.keys(dynamicVariantsById);
                dispatch(actions_addDynamicVariants(dynamicVariantsById, dynamicVariantIds));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchVariants.apply(this, arguments);
    }

    fetchVariants(); // Making variantIds to a string to prevent unessesary rerender (and refetch), thus disabling exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, shopId, dynamicVariants.byId, JSON.stringify(currentShopVariantIds)]);
  return dynamicVariants;
};

/* harmony default export */ var hooks_useGetDynamicVariants = __webpack_exports__["a"] = (useGetDynamicVariants_useGetDynamicVariants);

/***/ }),

/***/ "5Aug":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ Price_RegionPrice; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ Price_LocalPrice; });

// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var react = __webpack_require__("ZD0w");

// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__("q1tI");
var node_modules_react_default = /*#__PURE__*/__webpack_require__.n(node_modules_react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./data/regions.js
var regions = __webpack_require__("keR7");
var regions_default = /*#__PURE__*/__webpack_require__.n(regions);

// EXTERNAL MODULE: ./data/shops.js
var shops = __webpack_require__("z1id");
var shops_default = /*#__PURE__*/__webpack_require__.n(shops);

// CONCATENATED MODULE: ./components/shared/Price/RegionPrice.js
var __jsx = node_modules_react_default.a.createElement;






var RegionPrice_RegionPrice = function RegionPrice(_ref) {
  var price = _ref.price,
      currencyId = _ref.currencyId;
  return /*#__PURE__*/node_modules_react_default.a.createElement(react["NumberFormat"], {
    value: parseFloat(price),
    format: {
      style: 'currency',
      currency: currencyId,
      minimumFractionDigits: 0
    }
  });
};

// Map state to props
var RegionPrice_mapStateToProps = function mapStateToProps(state) {
  var regionId = state.settings.regionId;
  var shopId = regions_default.a.byId[regionId].shopId;
  var currencyId = shops_default.a.byId[shopId].currencyId;
  return {
    currencyId: currencyId
  };
};

/* harmony default export */ var Price_RegionPrice = (Object(es["b" /* connect */])(RegionPrice_mapStateToProps)(RegionPrice_RegionPrice));
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./styles/theme.js
var theme = __webpack_require__("NVT0");

// EXTERNAL MODULE: ./utils/convertToCurrency.js
var convertToCurrency = __webpack_require__("+YIU");

// EXTERNAL MODULE: ./data/countries.js
var countries = __webpack_require__("gT3G");

// EXTERNAL MODULE: ./components/atoms/Text/mixins/bodyTextMixins.js
var bodyTextMixins = __webpack_require__("hcoH");

// CONCATENATED MODULE: ./components/shared/Price/LocalPrice.js
var LocalPrice_jsx = node_modules_react_default.a.createElement;











var LocalPrice_LocalPrice = function LocalPrice(_ref) {
  var className = _ref.className,
      price = _ref.price,
      localCurrencyCode = _ref.localCurrencyCode,
      shopCurrencyCode = _ref.shopCurrencyCode;
  var priceFloat = parseFloat(price);
  var localPrice = Object(convertToCurrency["a" /* default */])(priceFloat, shopCurrencyCode, localCurrencyCode);
  return (// Do not show local price if country does not have conversion
    localCurrencyCode && localCurrencyCode !== shopCurrencyCode && /*#__PURE__*/node_modules_react_default.a.createElement(node_modules_react_default.a.Fragment, null, /*#__PURE__*/node_modules_react_default.a.createElement(StyledLocalPrice, {
      className: className
    }, "\u2248", ' ', /*#__PURE__*/node_modules_react_default.a.createElement(react["NumberFormat"], {
      value: Math.round(localPrice),
      format: {
        style: 'currency',
        currency: localCurrencyCode,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }
    })))
  );
};

var StyledLocalPrice = styled_components_browser_esm["default"].div.withConfig({
  displayName: "LocalPrice__StyledLocalPrice",
  componentId: "dw7q0h-0"
})(["", " color:", ";"], bodyTextMixins["c" /* bodyTextMixin3 */], theme["a" /* default */].colors.grey);
LocalPrice_LocalPrice.defaultProps = {
  className: ''
};

// Map state to props
var LocalPrice_mapStateToProps = function mapStateToProps(state) {
  var _state$settings = state.settings,
      countryId = _state$settings.countryId,
      regionId = _state$settings.regionId;
  var shopId = regions_default.a.byId[regionId].shopId;
  var shopCurrencyCode = shops_default.a.byId[shopId].currencyId;
  var localCurrencyCode = null;

  try {
    localCurrencyCode = countries["a" /* default */].byId[countryId].currencyId;
  } catch (e) {
    console.log("Country you selected does not support currency conversion ".concat(e));
  }

  return {
    localCurrencyCode: localCurrencyCode,
    shopCurrencyCode: shopCurrencyCode
  };
};

/* harmony default export */ var Price_LocalPrice = (Object(es["b" /* connect */])(LocalPrice_mapStateToProps)(LocalPrice_LocalPrice));
// CONCATENATED MODULE: ./components/shared/Price/index.js




/***/ }),

/***/ "5zck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./utils/hooks/useCheckRegion.js
var useCheckRegion = __webpack_require__("h5Ls");

// EXTERNAL MODULE: ./utils/loadDynamicScript.js
var loadDynamicScript = __webpack_require__("bQ3T");

// CONCATENATED MODULE: ./config/3rdPartyIds.js
var AFFIRM_ID = 'PS3CGLQXED1E8OWK';
var TRUSTED_SHOP_ID = 'X910A42A71C528D2A7FDC4EAC881296AF';
var GOOGLE_API_CLIENT_ID = '682795478599-crp8akoijpga4efodnllv19j9cf7dpib.apps.googleusercontent.com';
var GOOGLE_API_CLIENT_API_KEY = 'AIzaSyBwvqkNky40CZ3iBxyuFE19sN1kwj_tpUE';
var GOOGLE_TAG_MANAGER_ID = 'GTM-N9BNGMP';
var GOOGLE_ANALYTICS_ID = 'UA-60649204-1';
var FACEBOOK_PIXEL_ID = '1011075445596871';
var FACEBOOK_API_APP_ID = '195140778302300';
var GOOGLE_ADWORDS_ID = 'AW-940575952';
var BING_UET_ID = '26060438';
var TWITTER_ID = 'o1zun';
var KLAVIYO_US_PUBLIC_KEY = 'MkLxUz'; // US Klaviyo

var KLAVIYO_EU_PUBLIC_KEY = 'J2gddK'; // EU Klaviyo

var KLAVIYO_DE_PUBLIC_KEY = 'QygNtP'; // DE Klaviyo

var KLAVIYO_NO_PUBLIC_KEY = 'HnxnQq'; // NO Klaviyo

var KLAVIYO_DK_PUBLIC_KEY = 'NrMi5N'; // DK Klaviyo
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// CONCATENATED MODULE: ./components/shared/AdditionalScripts/TrustedShop/index.js
var __jsx = react_default.a.createElement;




 // The original aspect ratio (width: height) of the Trustbadge®
// of 2: 1 in the variant 'custom_reviews' or 1: 1 for the variant 'custom'.

var trustBadgeHeight = 60;
var trustBadgeWidth = 120;

var scriptLoadedCallback = function scriptLoadedCallback() {
  setTimeout(function () {
    // Timeout needed because the trustbadge is initiated asynchronously
    var trustbadgeElem = document.querySelector('[id^="trustbadge-container-"]');

    if (trustbadgeElem) {
      // Manually set z-index because it needst to be lower than the cart drawer
      // and the default value is the highest possible integer.
      trustbadgeElem.style.zIndex = 2;
    }
  }, 1000);
}; // Read more: https://support.trustedshops.com/en/apps/trustbadge-integration
// http://www.trustedshops.co.uk/support/trustbadge/trustbadge-custom


var TrustedShop_TrustedShop = function TrustedShop() {
  var _useCheckRegion = Object(useCheckRegion["a" /* default */])(),
      isDE = _useCheckRegion.isDE;

  var trustedBadgeContainerId = 'trusted-badge-container';
  Object(react["useEffect"])(function () {
    // eslint-disable-next-line no-underscore-dangle
    window._tsConfig = {
      yOffset: '0',

      /* offset from page bottom */
      variant: 'reviews',

      /* default, reviews, custom, custom_reviews */
      customElementId: '',

      /* required for variants custom and custom_reviews */
      trustcardDirection: '',

      /* for custom variants: topRight, topLeft, bottomRight, bottomLeft */
      customBadgeWidth: '',

      /* for custom variants: 40 - 90 (in pixels) */
      customBadgeHeight: '',

      /* for custom variants: 40 - 90 (in pixels) */
      disableResponsive: 'false',

      /* deactivate responsive behaviour */
      disableTrustbadge: 'false'
      /* deactivate trustbadge */

    }; // Load script on DE store

    if (isDE) {
      Object(loadDynamicScript["a" /* default */])("https://widgets.trustedshops.com/js/".concat(TRUSTED_SHOP_ID, ".js"), {
        id: 'trusted-shop-script',
        defer: true
      }, document.getElementById(trustedBadgeContainerId).parentElement, scriptLoadedCallback);
    }

    return function () {
      // remove badge when component unmounts
      var trustbadgeElem = document.querySelector('[id^="trustbadge-container-"]');

      if (trustbadgeElem) {
        trustbadgeElem.remove();
      }
    };
  }, [isDE]);
  return /*#__PURE__*/react_default.a.createElement(CustomTrustBadge, {
    id: trustedBadgeContainerId
  });
};

var CustomTrustBadge = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TrustedShop__CustomTrustBadge",
  componentId: "sc-1exg5lm-0"
})(["display:", ";position:fixed;bottom:0;right:0;height:", "px;width:", "px;border-radius:", "px;"], function (props) {
  return props.isShow ? 'block' : 'none';
}, trustBadgeHeight, trustBadgeWidth, function (props) {
  return props.theme.halfBaseline;
});
/* harmony default export */ var AdditionalScripts_TrustedShop = __webpack_exports__["a"] = (TrustedShop_TrustedShop);

/***/ }),

/***/ "FZPq":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products",
      function () {
        return __webpack_require__("nzsO");
      }
    ]);
  

/***/ }),

/***/ "HaE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _asyncToGenerator; });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ "Me73":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ molecules_FlexList_FlexList; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ FlexListJustifyContent; });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__("Epja");
var View_default = /*#__PURE__*/__webpack_require__.n(View);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__("HR29");
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/molecules/Composition/index.ts + 16 modules
var Composition = __webpack_require__("C2Jz");

// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/FlexList/FlexList.tsx
var __jsx = react_default.a.createElement;




var FlexListJustifyContent;

(function (FlexListJustifyContent) {
  FlexListJustifyContent["Start"] = "flex-start";
  FlexListJustifyContent["End"] = "flex-end";
  FlexListJustifyContent["Center"] = "center";
  FlexListJustifyContent["SpaceBetween"] = "space-between";
  FlexListJustifyContent["SpaceAround"] = "space-around";
  FlexListJustifyContent["SpaceEvenly"] = "space-evenly";
})(FlexListJustifyContent || (FlexListJustifyContent = {}));

var styles = StyleSheet_default.a.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap'
  }
});

var FlexList_FlexList = function FlexList(_ref) {
  var data = _ref.data,
      renderItem = _ref.renderItem,
      keyExtractor = _ref.keyExtractor,
      gapHorizontal = _ref.gapHorizontal,
      justifyContent = _ref.justifyContent,
      gapVertical = _ref.gapVertical;
  return /*#__PURE__*/react_default.a.createElement(Composition["g" /* default */], null, /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
    omitPadding: true,
    direction: Composition["d" /* LayoutDirection */].Row,
    alignX: Composition["c" /* LayoutAlignment */].Start,
    alignY: Composition["c" /* LayoutAlignment */].Start
  }, /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: [styles.container, {
      justifyContent: justifyContent,
      marginVertical: -gapVertical / 2,
      marginHorizontal: -gapHorizontal / 2
    }]
  }, data.map(function (item, index) {
    return /*#__PURE__*/react_default.a.createElement(View_default.a, {
      style: {
        marginVertical: gapVertical / 2,
        marginHorizontal: gapHorizontal / 2
      },
      key: keyExtractor(item)
    }, renderItem({
      index: index,
      item: item
    }), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
      direction: Composition["f" /* SpacerDirection */].Horizontal,
      size: gapHorizontal
    }));
  }))));
};

/* harmony default export */ var molecules_FlexList_FlexList = (FlexList_FlexList);
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/FlexList/index.ts


/***/ }),

/***/ "Qiyr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__("HR29");
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__("Epja");
var View_default = /*#__PURE__*/__webpack_require__.n(View);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/useWindowDimensions/index.js
var useWindowDimensions = __webpack_require__("6EzT");
var useWindowDimensions_default = /*#__PURE__*/__webpack_require__.n(useWindowDimensions);

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/styles/theme.ts
var theme = __webpack_require__("isV7");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/molecules/Composition/index.ts + 16 modules
var Composition = __webpack_require__("C2Jz");

// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/PromoBanner/index.tsx
var __jsx = react_default.a.createElement;






var styles = StyleSheet_default.a.create({
  contentWrapper: {
    flexShrink: 1,
    width: 'fit-content'
  },
  icon: {
    alignItems: 'flex-start'
  }
});

var PromoBanner_PromoBanner = function PromoBanner(_ref) {
  var colorBackground = _ref.colorBackground,
      icon = _ref.icon,
      content = _ref.content;

  var _useWindowDimensions = useWindowDimensions_default()(),
      width = _useWindowDimensions.width;

  return /*#__PURE__*/react_default.a.createElement(Composition["g" /* default */], null, /*#__PURE__*/react_default.a.createElement(Composition["a" /* BackgroundColor */], {
    color: colorBackground
  }), /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
    direction: Composition["d" /* LayoutDirection */].Row,
    alignX: Composition["c" /* LayoutAlignment */].Center,
    alignY: Composition["c" /* LayoutAlignment */].Center
  }, /*#__PURE__*/react_default.a.createElement(Composition["g" /* default */], {
    maxWidth: theme["c" /* ContentMaxWidth */].Medium
  }, /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
    omitPadding: true,
    forceNowrap: true,
    direction: Composition["d" /* LayoutDirection */].Row,
    alignX: Composition["c" /* LayoutAlignment */].Center,
    alignY: Composition["c" /* LayoutAlignment */].Center
  }, icon && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: styles.icon
  }, icon), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Horizontal,
    size: theme["l" /* Space */].Smaller
  })), /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: styles.contentWrapper
  }, content)))));
};

/* harmony default export */ var molecules_PromoBanner = (PromoBanner_PromoBanner);
// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Icon/index.tsx + 105 modules
var Icon = __webpack_require__("ZSX1");

// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__("ZD0w");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Text/index.tsx
var Text = __webpack_require__("Zd2Y");

// EXTERNAL MODULE: ./components/atoms/Link/index.tsx
var Link = __webpack_require__("ZT91");

// CONCATENATED MODULE: ./containers/summer-campaign/BannerLink.tsx
var BannerLink_jsx = react_default.a.createElement;





var BannerLink_BannerLink = function BannerLink(_ref) {
  var as = _ref.as,
      href = _ref.href,
      children = _ref.children;
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    as: as,
    href: href
  }, /*#__PURE__*/react_default.a.createElement("a", null, /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    textDecorationLine: Text["g" /* TextDecorationLine */].Underline,
    colorForeground: theme["a" /* Color */].Charcoal,
    type: Text["i" /* TextType */].CaptionLarge
  }, children)));
};

/* harmony default export */ var summer_campaign_BannerLink = (BannerLink_BannerLink);
// CONCATENATED MODULE: ./containers/summer-campaign/BannerContent.tsx
var BannerContent_jsx = react_default.a.createElement;






var BannerContent_BannerContent = function BannerContent() {
  return /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    colorForeground: theme["a" /* Color */].White,
    type: Text["i" /* TextType */].CaptionLarge
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "banner.sb3.summer.promobar.text",
    components: [/*#__PURE__*/react_default.a.createElement(summer_campaign_BannerLink, {
      as: "/products/?filter=speakers",
      href: "/products/?filter=speakers"
    })]
  }));
};

/* harmony default export */ var summer_campaign_BannerContent = (BannerContent_BannerContent);
// CONCATENATED MODULE: ./containers/summer-campaign/index.tsx
var summer_campaign_jsx = react_default.a.createElement;






var summer_campaign_Promobar = function Promobar() {
  return /*#__PURE__*/react_default.a.createElement(molecules_PromoBanner, {
    colorBackground: theme["a" /* Color */].Primary,
    icon: /*#__PURE__*/react_default.a.createElement(Icon["b" /* default */], {
      color: theme["a" /* Color */].Charcoal,
      id: Icon["a" /* IconId */].Thunder,
      size: theme["d" /* IconSize */].Small
    }),
    content: /*#__PURE__*/react_default.a.createElement(summer_campaign_BannerContent, null)
  });
};

/* harmony default export */ var summer_campaign = __webpack_exports__["a"] = (summer_campaign_Promobar);

/***/ }),

/***/ "Z1QS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// CONCATENATED MODULE: ./components/atoms/Picture/Placeholder.js

var Placeholder = styled_components_browser_esm["default"].img.withConfig({
  displayName: "Placeholder",
  componentId: "p1aa3b-0"
})(["background-size:cover;filter:blur(10px);background-repeat:no-repeat;width:100%;height:100%;opacity:", ";transition:opacity 0.3s ease-in-out;"], function (props) {
  return props.show ? 0.3 : 0;
});
/* harmony default export */ var Picture_Placeholder = (Placeholder);
// CONCATENATED MODULE: ./components/atoms/Picture/Img.js

var Img = styled_components_browser_esm["default"].img.withConfig({
  displayName: "Img",
  componentId: "sc-7e0euz-0"
})(["width:100%;height:100%;opacity:", ";transition:opacity 0.3s ease-in-out;", " ", ";", ";"], function (props) {
  return props.loaded ? 1 : 0;
}, function (_ref) {
  var _ref$cover = _ref.cover,
      cover = _ref$cover === void 0 ? 'both' : _ref$cover,
      _ref$center = _ref.center,
      center = _ref$center === void 0 ? true : _ref$center,
      fullWidth = _ref.fullWidth;
  return fullWidth ? "\n    position: absolute;\n    top: ".concat(center ? '50%' : 0, ";\n    left: ").concat(center ? '50%' : 0, ";\n    transform: ").concat(center ? 'translate(-50%, -50%)' : 'none', ";\n    width: ").concat(cover === 'width' ? '100%' : 'auto', ";\n    height: ").concat(cover === 'height' ? '100%' : 'auto', ";\n    min-height: ").concat(cover === 'both' ? '100%' : 'none', ";\n    min-width: ").concat(cover === 'both' ? '100%' : 'none', ";\n  ") : null;
}, function (props) {
  return props.objectFit && "object-fit: ".concat(props.objectFit, ";");
}, function (props) {
  return props.objectPosition && "object-position: ".concat(props.objectPosition, ";");
});
/* harmony default export */ var Picture_Img = (Img);
// CONCATENATED MODULE: ./components/atoms/Picture/Wrappers.js

var Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Wrappers__Wrapper",
  componentId: "sc-10xggky-0"
})(["width:100%;height:100%;position:relative;overflow:hidden;"]);
var PictureWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Wrappers__PictureWrapper",
  componentId: "sc-10xggky-1"
})(["overflow:hidden;top:0;left:0;right:0;bottom:0;position:absolute;"]);

// CONCATENATED MODULE: ./components/atoms/Picture/index.js
var __jsx = react_default.a.createElement;





function Picture(_ref) {
  var alt = _ref.alt,
      placeholder = _ref.placeholder,
      fullWidth = _ref.fullWidth,
      crop = _ref.crop,
      images = _ref.images,
      className = _ref.className,
      objectFit = _ref.objectFit,
      objectPosition = _ref.objectPosition,
      cover = _ref.cover;

  var _useState = Object(react["useState"])(false),
      loaded = _useState[0],
      setLoaded = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      allowLoading = _useState2[0],
      setAllowLoading = _useState2[1];

  var defaultImg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkEAMAABwAGLaurXYAAAAASUVORK5CYII=';
  var imageRef = Object(react["useRef"])(null);
  Object(react["useEffect"])(function () {
    var img = imageRef.current;

    if (img && img.complete) {
      setLoaded(true);
    }
  }, [setLoaded]); // eslint-disable-next-line consistent-return

  Object(react["useEffect"])(function () {
    // Check if IntersectionObserver available in window before execute the code to lazy-load images
    if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype) {
      // TODO: <Turbo> Load Polyfill if IntersectionObserver not available.
      // Polyfill is loaded already using PolyfillIO component but for some reason does not
      // work on Safari
      // Set up callback to handle images on intersecting
      var callback = function callback(entries) {
        if (!allowLoading) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setAllowLoading(true);
            }
          });
        }
      }; // Set up Intersection observer options


      var observerOptions = {
        rootMargin: '200px',
        threshold: 0.1
      };
      var observer = new IntersectionObserver(callback, observerOptions);
      var image = imageRef.current;
      observer.observe(image);
      return function () {
        observer.unobserve(image);
      };
    } // If Intersection Observer NOT available, load all images


    setAllowLoading(true);
  }, [setAllowLoading, allowLoading]);
  return /*#__PURE__*/react_default.a.createElement(Wrapper, {
    className: className
  }, placeholder && /*#__PURE__*/react_default.a.createElement(Picture_Placeholder, {
    src: placeholder,
    alt: alt,
    show: !loaded
  }), /*#__PURE__*/react_default.a.createElement(PictureWrapper, {
    fullWidth: fullWidth
  }, /*#__PURE__*/react_default.a.createElement("picture", null, allowLoading && images.reduce(function (acc, image) {
    var widthString = image.width ? "w=".concat(image.width) : '';
    var heightString = image.height ? "h=".concat(image.height) : '';
    var image1x = "".concat(image.src, "?").concat(widthString, "&").concat(heightString, "&fit=").concat(crop ? 'crop' : 'max');
    var image2x = "".concat(image.src, "?").concat(widthString, "&").concat(heightString, "&auto=enhance&dpr=2&fit=").concat(crop ? 'crop' : 'max');
    acc.push( /*#__PURE__*/react_default.a.createElement("source", {
      key: "".concat(image.key, "_webp"),
      media: image.media,
      srcSet: "".concat(image1x, "&fm=webp 1x,").concat(image2x, "&fm=webp 2x"),
      type: "image/webp"
    }), /*#__PURE__*/react_default.a.createElement("source", {
      key: "".concat(image.key),
      media: image.media,
      srcSet: "".concat(image1x, " 1x,").concat(image2x, " 2x"),
      type: "image/jpeg"
    }));
    return acc;
  }, []), /*#__PURE__*/react_default.a.createElement(Picture_Img, {
    alt: alt,
    src: placeholder || defaultImg,
    loaded: loaded,
    cover: cover,
    onLoad: function onLoad() {
      return setLoaded(true);
    },
    objectFit: objectFit,
    objectPosition: objectPosition,
    ref: imageRef,
    fullWidth: fullWidth
  }))));
} // defaultProps


Picture.defaultProps = {
  images: [],
  fullWidth: false,
  placeholder: null,
  crop: false,
  cover: 'both',
  className: '',
  objectFit: '',
  objectPosition: ''
}; // propTypes

/* harmony default export */ var atoms_Picture = __webpack_exports__["a"] = (Picture);

/***/ }),

/***/ "bQ3T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Create a script tag and load dynamically
 *
 * @param  {string} url url of script
 * @param  {object} attrs custom attributes e.g. { id: "", async: true }
 * @param  {element} parent parent element where script is appended after
 * @param  {func} callback callback function after script is loaded
 */
var loadDynamicScript = function loadDynamicScript(url) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    id: null
  };
  var parent = arguments.length > 2 ? arguments[2] : undefined;
  var callback = arguments.length > 3 ? arguments[3] : undefined;
  var existingScript = document.getElementById(attrs.id);

  if (!existingScript) {
    var script = document.createElement('script');
    script.src = url; // Add custom attributes

    if (Object.keys(attrs).length > 0) {
      Object.keys(attrs).forEach(function (key) {
        return !!attrs[key] && script.setAttribute(key, attrs[key]);
      });
    } // Append script


    if (parent) {
      parent.appendChild(script);
    } else {
      document.head.appendChild(script);
    } // Callback after element loaded


    script.onload = function () {
      if (callback) callback();
    };
  }

  if (existingScript && callback) callback();
};

/* harmony default export */ __webpack_exports__["a"] = (loadDynamicScript);

/***/ }),

/***/ "nzsO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./components/wrappers/Layout/index.js + 33 modules
var Layout = __webpack_require__("8hyx");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("20a2");

// EXTERNAL MODULE: ./node_modules/@lingui/react/index.js
var _lingui_react = __webpack_require__("ZD0w");

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/styles/theme.ts
var theme = __webpack_require__("isV7");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Icon/index.tsx + 105 modules
var Icon = __webpack_require__("ZSX1");

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__("Epja");
var View_default = /*#__PURE__*/__webpack_require__.n(View);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__("HR29");
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/TouchableOpacity/index.js
var TouchableOpacity = __webpack_require__("5Lw1");
var TouchableOpacity_default = /*#__PURE__*/__webpack_require__.n(TouchableOpacity);

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Text/index.tsx
var Text = __webpack_require__("Zd2Y");

// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Selectable/Selectable.tsx
var __jsx = react_default.a.createElement;






var styles = StyleSheet_default.a.create({
  selectableContainer: {
    borderWidth: 2,
    alignSelf: 'auto'
  },
  selectableContent: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: theme["j" /* Size */].BaseUnit * 2,
    paddingVertical: theme["j" /* Size */].BaseUnit * 1
  },
  iconContainer: {
    marginLeft: 0 - theme["j" /* Size */].BaseUnit,
    marginRight: theme["j" /* Size */].BaseUnit
  }
});

var Selectable_Selectable = function Selectable(_ref) {
  var selected = _ref.selected,
      onPress = _ref.onPress,
      title = _ref.title,
      colorBackground = _ref.colorBackground,
      colorForeground = _ref.colorForeground;
  var styleSelectableContainer = styles.selectableContainer; // Invert colors if selected

  var foregroundColor = selected ? colorBackground : colorForeground;
  var backgroundColor = selected ? colorForeground : colorBackground;
  styleSelectableContainer = StyleSheet_default.a.flatten([styleSelectableContainer, {
    borderColor: colorForeground
  }]);
  var styleSelectableContent = StyleSheet_default.a.flatten([styles.selectableContent, {
    backgroundColor: backgroundColor
  }]);

  if (colorBackground !== theme["a" /* Color */].Transparent) {
    styleSelectableContainer = StyleSheet_default.a.flatten([styleSelectableContainer]);
  }

  return /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: styleSelectableContainer
  }, /*#__PURE__*/react_default.a.createElement(TouchableOpacity_default.a, {
    onPress: onPress,
    activeOpacity: theme["e" /* Opacity */].Translucent
  }, /*#__PURE__*/react_default.a.createElement(View_default.a, {
    style: styleSelectableContent
  }, /*#__PURE__*/react_default.a.createElement(Text["j" /* default */], {
    type: Text["i" /* TextType */].Button,
    textDecorationLine: Text["g" /* TextDecorationLine */].None,
    colorForeground: foregroundColor
  }, title))));
};

/* harmony default export */ var atoms_Selectable_Selectable = (Selectable_Selectable);
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Selectable/index.ts

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/molecules/FlexList/index.ts + 1 modules
var FlexList = __webpack_require__("Me73");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/molecules/Composition/index.ts + 16 modules
var Composition = __webpack_require__("C2Jz");

// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/SelectableList/SelectableList.tsx
var SelectableList_jsx = react_default.a.createElement;








var SelectableList_SelectableList = function SelectableList(_ref) {
  var colorForeground = _ref.colorForeground,
      colorBackground = _ref.colorBackground,
      iconId = _ref.iconId,
      selectables = _ref.selectables,
      onChange = _ref.onChange;

  var renderItemSelectable = function renderItemSelectable(_ref2) {
    var _ref2$item = _ref2.item,
        title = _ref2$item.title,
        id = _ref2$item.id,
        isSelected = _ref2$item.isSelected;
    return /*#__PURE__*/react_default.a.createElement(atoms_Selectable_Selectable, {
      title: title,
      selected: isSelected,
      colorForeground: colorForeground,
      colorBackground: colorBackground,
      onPress: function onPress() {
        return onChange(id);
      }
    });
  };

  return /*#__PURE__*/react_default.a.createElement(Composition["g" /* default */], null, /*#__PURE__*/react_default.a.createElement(Composition["b" /* Layout */], {
    omitPadding: true,
    direction: Composition["d" /* LayoutDirection */].Row,
    alignX: Composition["c" /* LayoutAlignment */].Start,
    alignY: Composition["c" /* LayoutAlignment */].Start
  }, iconId && /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(View_default.a, null, /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Vertical,
    size: theme["l" /* Space */].Tiny
  }), /*#__PURE__*/react_default.a.createElement(Icon["b" /* default */], {
    id: iconId,
    size: theme["d" /* IconSize */].Small,
    color: colorForeground
  })), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Horizontal,
    size: theme["l" /* Space */].Smaller
  })), /*#__PURE__*/react_default.a.createElement(FlexList["b" /* default */], {
    justifyContent: FlexList["a" /* FlexListJustifyContent */].Start,
    data: selectables,
    keyExtractor: function keyExtractor(_ref3) {
      var id = _ref3.id;
      return id;
    },
    renderItem: renderItemSelectable,
    gapVertical: theme["l" /* Space */].Smaller,
    gapHorizontal: theme["l" /* Space */].Small
  })));
};

/* harmony default export */ var molecules_SelectableList_SelectableList = (SelectableList_SelectableList);
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/SelectableList/utils.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var utils_useSelectableListState = function useSelectableListState(initialSelectables) {
  var _useState = Object(react["useState"])(initialSelectables),
      selectables = _useState[0],
      setSelectables = _useState[1];

  var onChange = function onChange(id) {
    setSelectables(selectables.map(function (selectable) {
      return selectable.id !== id ? selectable : _objectSpread(_objectSpread({}, selectable), {}, {
        isSelected: !selectable.isSelected
      });
    }));
  };

  return {
    selectables: selectables,
    onChange: onChange
  };
};
// CONCATENATED MODULE: ./node_modules/@soundboks/sb-components/src/molecules/SelectableList/index.ts


// EXTERNAL MODULE: ./components/shared/Row/index.js
var Row = __webpack_require__("OfJt");

// EXTERNAL MODULE: ./data/shops.js
var shops = __webpack_require__("z1id");
var shops_default = /*#__PURE__*/__webpack_require__.n(shops);

// EXTERNAL MODULE: ./data/regions.js
var regions = __webpack_require__("keR7");
var regions_default = /*#__PURE__*/__webpack_require__.n(regions);

// EXTERNAL MODULE: ./data/productImages.js
var productImages = __webpack_require__("GQ8G");

// EXTERNAL MODULE: ./data/abstractProducts.js
var abstractProducts = __webpack_require__("eTmy");
var abstractProducts_default = /*#__PURE__*/__webpack_require__.n(abstractProducts);

// EXTERNAL MODULE: ./utils/hooks/useGetDynamicVariants.ts + 2 modules
var useGetDynamicVariants = __webpack_require__("3f9c");

// EXTERNAL MODULE: ./utils/hooks/useCheckRegion.js
var useCheckRegion = __webpack_require__("h5Ls");

// EXTERNAL MODULE: ./data/productCategories.js
var productCategories = __webpack_require__("1y9i");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./styles/theme.js
var styles_theme = __webpack_require__("NVT0");

// EXTERNAL MODULE: ./utils/paramToResolutions.js
var paramToResolutions = __webpack_require__("vE80");

// EXTERNAL MODULE: ./components/atoms/Link/index.tsx
var Link = __webpack_require__("ZT91");

// EXTERNAL MODULE: ./components/atoms/Text/index.js + 17 modules
var atoms_Text = __webpack_require__("wCgk");

// EXTERNAL MODULE: ./components/pages/product/Soundboks2/Overview/Reviews/UserReviews.js + 1 modules
var UserReviews = __webpack_require__("v04A");

// EXTERNAL MODULE: ./components/atoms/Button/index.js + 7 modules
var Button = __webpack_require__("8BE4");

// CONCATENATED MODULE: ./components/pages/Products/Reviews.js
var Reviews_jsx = react_default.a.createElement;










var Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Reviews__Wrapper",
  componentId: "iguxr6-0"
})(["position:relative;overflow:hidden;background-color:", ";", ";", ";border-bottom:3px solid white;> div:last-child{position:relative;@media ", "{padding:0;}}"], styles_theme["a" /* default */].colors.black, Object(paramToResolutions["a" /* default */])('padding-top', [100, 70, 150]), Object(paramToResolutions["a" /* default */])('padding-bottom', [30, 70, 120]), styles_theme["a" /* default */].breakpoints.onlyMobile);
var ContentRow = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "Reviews__ContentRow",
  componentId: "iguxr6-1"
})(["position:relative;z-index:1;> div:first-child{position:relative;}"]);
var BackgroundText = Object(styled_components_browser_esm["default"])(atoms_Text["g" /* Highlight1 */]).withConfig({
  displayName: "Reviews__BackgroundText",
  componentId: "iguxr6-2"
})(["position:absolute;", ";left:0;color:", ";@media ", "{display:none;}"], Object(paramToResolutions["a" /* default */])('top', [24, -24]), styles_theme["a" /* default */].colors.grey1, styles_theme["a" /* default */].breakpoints.desktopLarge);
var BackgroundTextLarge = Object(styled_components_browser_esm["default"])(BackgroundText).withConfig({
  displayName: "Reviews__BackgroundTextLarge",
  componentId: "iguxr6-3"
})(["display:none;@media ", "{z-index:-1;left:-4em;top:-2em;display:block;}"], styles_theme["a" /* default */].breakpoints.desktopLarge);
var StyledLinkButton = Object(styled_components_browser_esm["default"])(Button["e" /* StandardButton */]).withConfig({
  displayName: "Reviews__StyledLinkButton",
  componentId: "iguxr6-4"
})(["margin:", "px auto 0 auto;width:", "px;background-color:", ";@media ", "{width:", "px;}@media ", "{width:", "px;}"], styles_theme["a" /* default */].baseline * 3, styles_theme["a" /* default */].baseline * 23, styles_theme["a" /* default */].colors.white, styles_theme["a" /* default */].breakpoints.desktop, styles_theme["a" /* default */].baseline * 30, styles_theme["a" /* default */].breakpoints.desktop, styles_theme["a" /* default */].baseline * 40);

var Reviews_LinkButton = function LinkButton(_ref) {
  var as = _ref.as,
      href = _ref.href;
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    as: as,
    href: href,
    passHref: true
  }, /*#__PURE__*/react_default.a.createElement(StyledLinkButton, {
    flexButton: true,
    id: "products-reviews__button--seeAll"
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "See all reviews"
  })));
};

var Reviews_Reviews = function Reviews(_ref2) {
  var productHandle = _ref2.productHandle;
  return /*#__PURE__*/react_default.a.createElement(Wrapper, null, /*#__PURE__*/react_default.a.createElement(BackgroundText, null, "Get loud", /*#__PURE__*/react_default.a.createElement("br", null), "Get loud", /*#__PURE__*/react_default.a.createElement("br", null), "Get loud"), /*#__PURE__*/react_default.a.createElement(ContentRow, null, /*#__PURE__*/react_default.a.createElement(UserReviews["a" /* default */], {
    productHandle: productHandle
  }), /*#__PURE__*/react_default.a.createElement(Reviews_LinkButton, {
    as: "/products/".concat(productHandle, "/reviews"),
    href: "/products/product?productHandle=".concat(productHandle, "&subPage=reviews")
  }), /*#__PURE__*/react_default.a.createElement(BackgroundTextLarge, null, "Get loud", /*#__PURE__*/react_default.a.createElement("br", null), "Get loud", /*#__PURE__*/react_default.a.createElement("br", null), "Get loud", /*#__PURE__*/react_default.a.createElement("br", null), "Get loud")));
};

/* harmony default export */ var Products_Reviews = (Reviews_Reviews);
// EXTERNAL MODULE: ./components/shared/Price/index.js + 2 modules
var Price = __webpack_require__("5Aug");

// EXTERNAL MODULE: ./node_modules/@soundboks/sb-components/src/atoms/Skeleton/index.tsx
var Skeleton = __webpack_require__("OWaX");

// EXTERNAL MODULE: ./data/productMainUrls.js
var productMainUrls = __webpack_require__("v8DS");

// EXTERNAL MODULE: ./components/shared/ProductSticker/index.js
var ProductSticker = __webpack_require__("+SvR");

// EXTERNAL MODULE: ./components/shared/ProductStickerFreeReturns/index.js
var ProductStickerFreeReturns = __webpack_require__("hf/d");

// EXTERNAL MODULE: ./components/shared/ProductStickerMikkeller/index.jsx
var ProductStickerMikkeller = __webpack_require__("psra");

// EXTERNAL MODULE: ./components/shared/ProductStickerArtistEditions/index.js
var ProductStickerArtistEditions = __webpack_require__("MPic");

// EXTERNAL MODULE: ./components/shared/ProductStickerLGBTUngdom/index.tsx
var ProductStickerLGBTUngdom = __webpack_require__("St8e");

// EXTERNAL MODULE: ./components/shared/ProductStickerRedCross/index.tsx
var ProductStickerRedCross = __webpack_require__("R7Cx");

// CONCATENATED MODULE: ./components/pages/Products/shared/ProductOverlay/ProductOverlay.js

var ProductOverlay_ProductOverlay = styled_components_browser_esm["default"].a.withConfig({
  displayName: "ProductOverlay",
  componentId: "sc-1na8uax-0"
})(["pointer-events:all;display:flex;flex-flow:column;align-items:center;justify-content:center;position:absolute;top:0;left:0;width:100%;height:100%;z-index:1;transition:visibility 0s,opacity 0.1s linear,background-color 0.08s ease-in-out;border-radius:", ";&:hover{text-decoration:none;background-color:", ";visibility:visible;opacity:1;button{visibility:visible;opacity:1;}}"], function (props) {
  return props.theme.sizes.radius;
}, function (props) {
  return props.theme.overlay.light;
});
/* harmony default export */ var shared_ProductOverlay_ProductOverlay = (ProductOverlay_ProductOverlay);
// CONCATENATED MODULE: ./components/pages/Products/shared/ProductOverlay/ProductOverlayButtonGroup.js

var ProductOverlayButtonGroup = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductOverlayButtonGroup",
  componentId: "sc-12emdj3-0"
})(["width:", "px;@media ", "{width:", "px;}@media ", "{width:", "px;}button{pointer-events:all;z-index:2;visibility:hidden;opacity:0;}"], function (props) {
  return props.theme.baseline * 22;
}, function (props) {
  return props.theme.breakpoints.desktop;
}, function (props) {
  return props.theme.baseline * 25;
}, function (props) {
  return props.theme.breakpoints.desktopLarge;
}, function (props) {
  return props.theme.baseline * 30;
});
/* harmony default export */ var ProductOverlay_ProductOverlayButtonGroup = (ProductOverlayButtonGroup);
// CONCATENATED MODULE: ./components/pages/Products/shared/ProductOverlay/index.js


// EXTERNAL MODULE: ./utils/generateClickableId.js
var generateClickableId = __webpack_require__("7dJx");

// EXTERNAL MODULE: ./utils/product/checkProduct.js
var checkProduct = __webpack_require__("aPyg");

// CONCATENATED MODULE: ./components/pages/Products/Product/ProductOverlay/index.js
var ProductOverlay_jsx = react_default.a.createElement;

















var Product_ProductOverlay_ProductOverlay = function ProductOverlay(_ref) {
  var handle = _ref.handle;

  var _useCheckRegion = Object(useCheckRegion["a" /* default */])(),
      isNA = _useCheckRegion.isNA,
      isDK = _useCheckRegion.isDK,
      isNO = _useCheckRegion.isNO;

  var _checkProduct = Object(checkProduct["a" /* checkProduct */])(handle),
      isBatteryboks = _checkProduct.isBatteryboks,
      isBatteryboks1 = _checkProduct.isBatteryboks1,
      isBackpack = _checkProduct.isBackpack,
      isSoundboksGo = _checkProduct.isSoundboksGo,
      isSoundboksGen2 = _checkProduct.isSoundboksGen2,
      isSoundboksGen3 = _checkProduct.isSoundboksGen3,
      isExplorerPack = _checkProduct.isExplorerPack,
      isAdventurePack = _checkProduct.isAdventurePack,
      isMikkellerEdition = _checkProduct.isMikkellerEdition,
      isArtistEditionsGrill = _checkProduct.isArtistEditionsGrill,
      isLGBTUngdom = _checkProduct.isLGBTUngdom,
      isGeorgeBakerEdition = _checkProduct.isGeorgeBakerEdition,
      isRedCrossPackage = _checkProduct.isRedCrossPackage,
      isZackRosebrughGrill = _checkProduct.isZackRosebrughGrill,
      isPowerPack = _checkProduct.isPowerPack,
      isCarrierStrap = _checkProduct.isCarrierStrap;

  var productBuyPageHandler = "/products/product?productHandle=".concat(handle);
  var productBuyPageURL = "/products/".concat(handle);
  var hasSubPage = !!abstractProducts_default.a.byId[handle].subPages.includes('overview');
  return /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: productBuyPageHandler,
    as: productBuyPageURL
  }, /*#__PURE__*/react_default.a.createElement(shared_ProductOverlay_ProductOverlay, {
    id: Object(generateClickableId["a" /* generateClickableId */])(2, 'Shop', 'Product', handle)
  }, /*#__PURE__*/react_default.a.createElement(ProductOverlay_ProductOverlayButtonGroup, null, /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: productBuyPageHandler,
    as: productBuyPageURL
  }, /*#__PURE__*/react_default.a.createElement(Button["c" /* PrimaryShopButton */], {
    id: Object(generateClickableId["a" /* generateClickableId */])(2, 'Shop', handle, 'Buy'),
    fullWidth: true
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "BUY"
  }))), hasSubPage && /*#__PURE__*/react_default.a.createElement(Link["a" /* default */], {
    href: productMainUrls["a" /* default */][handle].handler,
    as: productMainUrls["a" /* default */][handle].url
  }, /*#__PURE__*/react_default.a.createElement(Button["d" /* SecondaryShopButton */], {
    id: Object(generateClickableId["a" /* generateClickableId */])(2, 'Shop', handle, 'LearnMore'),
    fullWidth: true
  }, /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
    id: "Learn more"
  })))), (isSoundboksGo || isSoundboksGen3) && /*#__PURE__*/react_default.a.createElement(ProductSticker["a" /* default */], {
    header: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "product.option.label.accessories",
      components: [/*#__PURE__*/react_default.a.createElement("br", null)]
    }),
    large: true,
    moveLeft: true
  }), isBatteryboks && /*#__PURE__*/react_default.a.createElement(ProductSticker["a" /* default */], {
    header: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "page.products.card.sticker.compatible.header"
    }),
    body: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "page.products.card.sticker.compatible.body.all"
    }),
    large: true
  }), isCarrierStrap && /*#__PURE__*/react_default.a.createElement(ProductSticker["a" /* default */], {
    header: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "page.products.card.sticker.compatible.header"
    }),
    body: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "page.products.card.sticker.compatible.body.sbgo"
    }),
    large: true
  }), isBatteryboks1 && /*#__PURE__*/react_default.a.createElement(ProductSticker["a" /* default */], {
    header: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "page.products.card.sticker.compatible.header"
    }),
    body: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "page.products.card.sticker.compatible.body",
      components: [/*#__PURE__*/react_default.a.createElement("br", null)]
    }),
    large: true
  }), isBackpack && /*#__PURE__*/react_default.a.createElement(ProductSticker["a" /* default */], {
    header: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "page.products.card.sticker.compatible.header"
    }),
    body: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "page.products.card.sticker.compatible.body.sb2-sb3",
      components: [/*#__PURE__*/react_default.a.createElement("br", null)]
    }),
    large: true
  }), !isNA && isPowerPack && /*#__PURE__*/react_default.a.createElement(ProductSticker["a" /* default */], {
    header: /*#__PURE__*/react_default.a.createElement(_lingui_react["Trans"], {
      id: "page.products.card.sticker.powerpack.header",
      components: [/*#__PURE__*/react_default.a.createElement("br", null)]
    }),
    large: true
  }), isDK && isRedCrossPackage && /*#__PURE__*/react_default.a.createElement(ProductStickerRedCross["a" /* default */], null), !isNO && (!isNA && isSoundboksGen2 || !isNA && isExplorerPack || !isNA && isAdventurePack) && /*#__PURE__*/react_default.a.createElement(ProductStickerFreeReturns["a" /* default */], null), (isArtistEditionsGrill || isGeorgeBakerEdition || isZackRosebrughGrill) && /*#__PURE__*/react_default.a.createElement(ProductStickerArtistEditions["a" /* default */], null), isMikkellerEdition && /*#__PURE__*/react_default.a.createElement(ProductStickerMikkeller["a" /* default */], null), isLGBTUngdom && /*#__PURE__*/react_default.a.createElement(ProductStickerLGBTUngdom["a" /* default */], null)));
};

/* harmony default export */ var Product_ProductOverlay = (Product_ProductOverlay_ProductOverlay);
// CONCATENATED MODULE: ./components/pages/Products/Product/FinancingOptions/FinancingOptions.js


var FinancingOptions = styled_components_browser_esm["default"].div.withConfig({
  displayName: "FinancingOptions",
  componentId: "sc-1s1dvy8-0"
})(["grid-area:affirm;display:flex;align-items:center;justify-content:flex-start;padding:", ";br{display:none;@media ", "{display:block;}}@media ", "{padding:0;width:100%;}"], styles_theme["a" /* default */].space.inset.s, styles_theme["a" /* default */].breakpoints.desktopLarge, styles_theme["a" /* default */].breakpoints.tablet);
/* harmony default export */ var FinancingOptions_FinancingOptions = (FinancingOptions);
// EXTERNAL MODULE: ./components/shared/FinancingOption/index.js + 3 modules
var FinancingOption = __webpack_require__("f9Y1");

// CONCATENATED MODULE: ./components/pages/Products/Product/FinancingOptions/FinancingOption.js


var FinancingOption_FinancingOption = Object(styled_components_browser_esm["default"])(FinancingOption["a" /* default */]).withConfig({
  displayName: "FinancingOption",
  componentId: "sc-1mpcwtt-0"
})(["display:flex;margin:0;padding-top:0;text-transform:none;a{text-decoration:none;}"]);
/* harmony default export */ var FinancingOptions_FinancingOption = (FinancingOption_FinancingOption);
// CONCATENATED MODULE: ./components/pages/Products/Product/FinancingOptions/index.js


// EXTERNAL MODULE: ./components/atoms/Picture/index.js + 3 modules
var Picture = __webpack_require__("Z1QS");

// CONCATENATED MODULE: ./components/pages/Products/Product/ProductImage.js
var ProductImage_jsx = react_default.a.createElement;






var ProductImage_ProductImage = function ProductImage(_ref) {
  var image = _ref.image;
  return /*#__PURE__*/react_default.a.createElement(StyledProductImage, null, /*#__PURE__*/react_default.a.createElement(Picture["a" /* default */], {
    images: [{
      src: image.url,
      media: styles_theme["a" /* default */].breakpoints.desktopLarge,
      width: 480,
      key: '1'
    }, {
      src: image.url,
      width: 400,
      key: '2'
    }],
    placeholder: image.placeholder,
    alt: "Hero image",
    fullWidth: true
  }));
};

var StyledProductImage = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductImage__StyledProductImage",
  componentId: "sc-11ys0ok-0"
})(["margin:0 auto;", ";@media ", "{max-width:350px;}img{width:100%;height:auto;}"], Object(paramToResolutions["a" /* default */])('width', ['100%', 210, 300, 420]), function (props) {
  return props.theme.breakpoints.onlyMobile;
});
ProductImage_ProductImage.defaultProps = {
  image: {}
};
/* harmony default export */ var Product_ProductImage = (ProductImage_ProductImage);
// CONCATENATED MODULE: ./components/pages/Products/Product/ProductTitle.js
var ProductTitle_jsx = react_default.a.createElement;






var ProductTitle_ProductTitle = function ProductTitle(_ref) {
  var title = _ref.title,
      price = _ref.price,
      oldPrice = _ref.oldPrice,
      hidePrice = _ref.hidePrice,
      altTheme = _ref.altTheme,
      handle = _ref.handle;
  return /*#__PURE__*/react_default.a.createElement(Title, {
    altTheme: altTheme
  }, title, /*#__PURE__*/react_default.a.createElement("br", null), oldPrice && !hidePrice && /*#__PURE__*/react_default.a.createElement("span", null, /*#__PURE__*/react_default.a.createElement(Price["b" /* RegionPrice */], {
    price: oldPrice
  })), !hidePrice && /*#__PURE__*/react_default.a.createElement("span", null, /*#__PURE__*/react_default.a.createElement(Price["b" /* RegionPrice */], {
    price: price
  })));
};

var Title = Object(styled_components_browser_esm["default"])(atoms_Text["d" /* H2 */]).withConfig({
  displayName: "ProductTitle__Title",
  componentId: "z47wuk-0"
})(["color:", ";"], function (_ref2) {
  var altTheme = _ref2.altTheme;
  return altTheme ? styles_theme["a" /* default */].colors.white : styles_theme["a" /* default */].colors.black;
});
ProductTitle_ProductTitle.defaultProps = {
  oldPrice: null,
  hidePrice: false
};
/* harmony default export */ var Product_ProductTitle = (ProductTitle_ProductTitle);
// CONCATENATED MODULE: ./components/pages/Products/Product/index.js
var Product_jsx = react_default.a.createElement;













var Product_Product = function Product(_ref) {
  var handle = _ref.handle,
      title = _ref.title,
      image = _ref.image,
      price = _ref.price,
      oldPrice = _ref.oldPrice,
      affirmPrice = _ref.affirmPrice,
      hidePrice = _ref.hidePrice,
      variantIds = _ref.variantIds;
  var useAltTheme = handle === 'soundboks-gen-3' || handle === 'soundboks-go';

  var _useCheckRegion = Object(useCheckRegion["a" /* default */])(),
      isNA = _useCheckRegion.isNA,
      isCA = _useCheckRegion.isCA;

  return /*#__PURE__*/react_default.a.createElement(ProductWrapper, {
    hasDiscount: oldPrice,
    altTheme: useAltTheme
  }, /*#__PURE__*/react_default.a.createElement(Product_ProductOverlay, {
    handle: handle,
    variantId: variantIds[0]
  }), !price ? /*#__PURE__*/react_default.a.createElement(react_default.a.Fragment, null, /*#__PURE__*/react_default.a.createElement(Skeleton["a" /* Skeleton */], {
    width: theme["j" /* Size */].BaseUnit * 20,
    height: theme["j" /* Size */].BaseUnit * 3
  }), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    direction: Composition["f" /* SpacerDirection */].Vertical,
    size: theme["l" /* Space */].Tiny
  }), /*#__PURE__*/react_default.a.createElement(Skeleton["a" /* Skeleton */], {
    width: theme["j" /* Size */].BaseUnit * 10,
    height: theme["j" /* Size */].BaseUnit * 3
  })) : /*#__PURE__*/react_default.a.createElement(Product_ProductTitle, {
    handle: handle,
    title: title,
    price: price,
    oldPrice: oldPrice,
    hidePrice: hidePrice,
    altTheme: useAltTheme
  }), !hidePrice && /*#__PURE__*/react_default.a.createElement(Price["a" /* LocalPrice */], {
    price: price
  }), /*#__PURE__*/react_default.a.createElement(Product_ProductImage, {
    image: image
  }), affirmPrice && isNA && !isCA && /*#__PURE__*/react_default.a.createElement(FinancingOptions_FinancingOptions, null, /*#__PURE__*/react_default.a.createElement(FinancingOptions_FinancingOption, {
    option: "affirm",
    price: price,
    isBlackTheme: useAltTheme
  })));
};

var headerDiscountStyle = Object(styled_components_browser_esm["css"])(["h2{span{display:inline-block;}span:first-of-type{position:relative;&:after{content:'';position:absolute;width:100%;height:55%;left:0;border-bottom:3px solid ", ";}}span:last-child{display:inline-block;margin-left:10px;color:", ";}}"], styles_theme["a" /* default */].colors.primary, styles_theme["a" /* default */].colors.primary);
var ProductWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Product__ProductWrapper",
  componentId: "sc-1yemaww-0"
})(["position:relative;cursor:pointer;display:flex;flex-flow:column;justify-content:space-between;align-items:flex-start;background-color:", ";box-shadow:", ";border-radius:", ";transition:background-color 0.1s linear;padding:", "px;", " @media ", "{padding:", "px;}"], function (_ref2) {
  var altTheme = _ref2.altTheme;
  return altTheme ? styles_theme["a" /* default */].colors.black : styles_theme["a" /* default */].colors.white;
}, styles_theme["a" /* default */].shadows.standard, styles_theme["a" /* default */].sizes.radius, styles_theme["a" /* default */].halfBaseline * 3, function (props) {
  return props.hasDiscount && headerDiscountStyle;
}, styles_theme["a" /* default */].breakpoints.desktop, styles_theme["a" /* default */].halfBaseline * 5);
Product_Product.defaultProps = {
  affirmPrice: null,
  oldPrice: null,
  hidePrice: false
};
/* harmony default export */ var Products_Product = (Product_Product);
// CONCATENATED MODULE: ./components/pages/Products/ProductList/utils/processProducts.js
var processProducts_jsx = react_default.a.createElement;



var processProducts_processProducts = function processProducts(products, region, country, allVariants) {
  var res = products.reduce(function (acc, product) {
    if (product.availableRegions.includes(region) && !product.excludedCountries.includes(country)) {
      acc.push( /*#__PURE__*/react_default.a.createElement(Products_Product, {
        key: product.handle,
        allVariants: allVariants,
        handle: product.handle,
        title: product.title,
        image: product.image,
        price: product.price,
        oldPrice: product.oldPrice,
        affirmPrice: product.affirmPrice,
        klarnaPrice: product.klarnaPrice,
        hidePrice: product.hidePrice,
        variantIds: product.variantIds
      }));
    }

    return acc;
  }, []);
  return res;
};

/* harmony default export */ var utils_processProducts = (processProducts_processProducts);
// CONCATENATED MODULE: ./components/pages/Products/ProductList/index.js
var ProductList_jsx = react_default.a.createElement;








var ProductList_ProductList = function ProductList(_ref) {
  var products = _ref.products,
      regionId = _ref.regionId,
      countryId = _ref.countryId,
      allVariants = _ref.allVariants;
  var productInfo = products ? utils_processProducts(products, regionId, countryId, allVariants) : /*#__PURE__*/react_default.a.createElement(atoms_Text["d" /* H2 */], null, "Loading product...");
  return /*#__PURE__*/react_default.a.createElement(ProductList_Wrapper, null, /*#__PURE__*/react_default.a.createElement(GridWrapper, null, productInfo));
};

var ProductList_Wrapper = Object(styled_components_browser_esm["default"])(Row["a" /* default */]).withConfig({
  displayName: "ProductList__Wrapper",
  componentId: "i5ps92-0"
})(["padding-top:", "px;padding-bottom:", "px;"], styles_theme["a" /* default */].baseline * 4, styles_theme["a" /* default */].baseline * 4);
var GridWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductList__GridWrapper",
  componentId: "i5ps92-1"
})(["display:grid;grid-template-columns:1fr;", ";", ";@media ", "{grid-template-columns:1fr 1fr;}"], Object(paramToResolutions["a" /* default */])('grid-row-gap', [24, 16, 20]), Object(paramToResolutions["a" /* default */])('grid-column-gap', [16, 16, 20]), styles_theme["a" /* default */].breakpoints.tablet);
/* harmony default export */ var Products_ProductList = (ProductList_ProductList);
// CONCATENATED MODULE: ./components/pages/Products/index.tsx

var Products_jsx = react_default.a.createElement;

function Products_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Products_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Products_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Products_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















 // import { trackProductImpressions } from 'components/wrappers/PageTracker/utils';




var Products_getFiltersByFilterString = function getFiltersByFilterString() {
  var filterString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var filters = filterString.split(',').reduce(function (acc, f) {
    return Products_objectSpread(Products_objectSpread({}, acc), {}, Object(defineProperty["a" /* default */])({}, f, true));
  }, {});
  return [{
    id: productCategories["PRODUCT_CATEGORY_SPEAKERS"],
    title:
    /*i18n*/
    {
      id: "page.products.filter.speakers"
    },
    isSelected: filters[productCategories["PRODUCT_CATEGORY_SPEAKERS"]]
  }, {
    id: productCategories["PRODUCT_CATEGORY_GRILLS"],
    title:
    /*i18n*/
    {
      id: "page.products.filter.grills"
    },
    isSelected: filters[productCategories["PRODUCT_CATEGORY_GRILLS"]]
  }, {
    id: productCategories["PRODUCT_CATEGORY_ACCESSORIES"],
    title:
    /*i18n*/
    {
      id: "page.products.filter.accessories"
    },
    isSelected: filters[productCategories["PRODUCT_CATEGORY_ACCESSORIES"]]
  }, {
    id: productCategories["PRODUCT_CATEGORY_BUNDLES"],
    title:
    /*i18n*/
    {
      id: "page.products.filter.bundles"
    },
    isSelected: filters[productCategories["PRODUCT_CATEGORY_BUNDLES"]]
  }, {
    id: productCategories["PRODUCT_CATEGORY_SPECIAL_EDITIONS"],
    title:
    /*i18n*/
    {
      id: "page.products.filter.special-editions"
    },
    isSelected: filters[productCategories["PRODUCT_CATEGORY_SPECIAL_EDITIONS"]]
  }];
};

var getFilterStringByFilters = function getFilterStringByFilters(filters) {
  return filters.filter(function (f) {
    return f.isSelected;
  }).map(function (f) {
    return f.id;
  }).join(',');
}; // Products Component


var Products_Products = function Products() {
  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state;
  }),
      entities = _useSelector.entities,
      settings = _useSelector.settings;

  var regionId = settings.regionId,
      languageId = settings.languageId,
      countryId = settings.countryId;

  var _useCheckRegion = Object(useCheckRegion["a" /* default */])(),
      isNA = _useCheckRegion.isNA,
      isCA = _useCheckRegion.isCA,
      isDE = _useCheckRegion.isDE,
      isNO = _useCheckRegion.isNO,
      isDK = _useCheckRegion.isDK;

  var router = Object(next_router["useRouter"])();
  var filters = Object(react["useMemo"])(function () {
    var filterString = !router.query.filter || typeof router.query.filter === 'string' ? router.query.filter : router.query.filter[0];
    return Products_getFiltersByFilterString(filterString);
  }, [router.query.filter]);
  var onFilterChange = Object(react["useCallback"])(function (id) {
    var updatedFilters = filters.map(function (f) {
      if (f.id === id) return Products_objectSpread(Products_objectSpread({}, f), {}, {
        isSelected: !f.isSelected
      });
      return f;
    });
    var exclEnRegions = regionId !== 'eu' && regionId !== 'tr';
    var filterString = getFilterStringByFilters(updatedFilters);
    router.replace({
      pathname: "".concat(router.pathname),
      query: Products_objectSpread(Products_objectSpread({}, router.query), {}, {
        filter: filterString
      })
    }, {
      pathname: languageId === 'en' && exclEnRegions ? "".concat(regionId, "/en").concat(router.pathname) : "".concat(isNA ? '' : regionId).concat(router.pathname),
      query: Products_objectSpread({}, filterString ? {
        filter: filterString
      } : {})
    });
  }, [filters, regionId, languageId, router, isNA]);
  var filtersMap = filters.reduce(function (map, f) {
    return Products_objectSpread(Products_objectSpread({}, map), {}, Object(defineProperty["a" /* default */])({}, f.id, f.isSelected));
  }, {});
  var allProducts = entities.products,
      allVariants = entities.variants;
  var shopId = regions_default.a.byId[regionId].shopId;
  var shop = shops_default.a.byId[shopId];
  var someFiltersSelected = filters.find(function (f) {
    return f.isSelected;
  });
  var dynamicVariants = Object(useGetDynamicVariants["a" /* default */])(allVariants.allIds, shopId);
  var filteredProducts = Object(react["useMemo"])(function () {
    return allProducts.allIds.reduce(function (acc, productId) {
      // Set up variables
      var product = allProducts.byId[productId]; // Only proceed if ShopId matches client ShopId and product programmatically set to visible

      if (product.shopId === shopId) {
        try {
          var _dynamicVariants$byId, _dynamicVariants$byId2;

          var abstractProduct = abstractProducts_default.a.byId[product.handle];
          var matchesSomeFilter = abstractProduct.categories.find(function (c) {
            return filtersMap[c];
          }); // Return early if product does not contain any of the filtered categories
          // Also filter soundboks-gen-3 for Black Friday

          if (someFiltersSelected && !matchesSomeFilter) return acc;
          var availableRegions = abstractProduct.availableRegions,
              excludedCountries = abstractProduct.excludedCountries,
              viewWeight = abstractProduct.viewWeight,
              hidePrice = abstractProduct.hidePrice,
              categories = abstractProduct.categories; // Find product image

          var productImageId = abstractProduct.productImageIds[0];
          var image = productImages["byId"][productImageId]; // Find price and discount price
          // Dynamically getting the variants through hook

          var productVariant = allVariants.byId[product.variantIds[0]];
          var price = (_dynamicVariants$byId = dynamicVariants.byId[productVariant.id]) === null || _dynamicVariants$byId === void 0 ? void 0 : _dynamicVariants$byId.price;
          var compareAtPrice = (_dynamicVariants$byId2 = dynamicVariants.byId[productVariant.id]) === null || _dynamicVariants$byId2 === void 0 ? void 0 : _dynamicVariants$byId2.compareAtPrice;
          var oldPrice = compareAtPrice ? parseFloat(compareAtPrice) : null; // For product impressions. The list the product belongs to.

          var productList = categories[0];

          var getViewWeight = function getViewWeight(handle) {
            if (handle === 'weekender-pack') {
              if (isNA) return 4;
            }

            if (handle === 'soundboks-go') {
              if (isNA) return 1.2;
            }

            if (handle === 'elevation-pack' && (isNA || isCA)) return 3.0;
            return viewWeight;
          }; // Assemble info


          var preparedProduct = Products_objectSpread(Products_objectSpread({}, product), {}, {
            productList: productList,
            categories: categories,
            availableRegions: availableRegions,
            excludedCountries: excludedCountries,
            // prettier-ignore
            viewWeight: getViewWeight(product.handle),
            image: image,
            hidePrice: hidePrice,
            price: parseFloat(price),
            currencyCode: shop.currencyId,
            oldPrice: oldPrice,
            affirmPrice: isNA && !isCA && price > 50 ? price : null,
            klarnaPrice: (isNO || isDE || isDK) && price > 50 ? price : null
          });

          acc.push(preparedProduct);
        } catch (e) {
          console.log("Couldn't find handle or image for product ".concat(product.handle));
        }
      }

      return acc;
    }, []);
  }, [allProducts.allIds, allProducts.byId, allVariants.byId, dynamicVariants.byId, filtersMap, isDE, isDK, isNA, isCA, isNO, shop.currencyId, shopId, someFiltersSelected]); // Sorting products to display in order by `viewWeight`

  var sortedProducts = filteredProducts.sort(function (a, b) {
    return a.viewWeight - b.viewWeight;
  }).filter(function (product) {
    return product.handle !== '7-battery-swaps';
  });
  return /*#__PURE__*/react_default.a.createElement("div", null, /*#__PURE__*/react_default.a.createElement(Row["a" /* default */], null, /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    size: theme["l" /* Space */].Large,
    direction: Composition["f" /* SpacerDirection */].Vertical
  }), /*#__PURE__*/react_default.a.createElement(_lingui_react["I18n"], null, function (_ref) {
    var i18n = _ref.i18n;
    return /*#__PURE__*/react_default.a.createElement(molecules_SelectableList_SelectableList, {
      selectables: filters.map(function (f) {
        return Products_objectSpread(Products_objectSpread({}, f), {}, {
          title: i18n._(f.title)
        });
      }),
      colorBackground: theme["a" /* Color */].White,
      colorForeground: theme["a" /* Color */].Charcoal,
      onChange: onFilterChange,
      iconId: Icon["a" /* IconId */].SettingsApp
    });
  }), /*#__PURE__*/react_default.a.createElement(Composition["e" /* Spacer */], {
    size: theme["l" /* Space */].Medium,
    direction: Composition["f" /* SpacerDirection */].Vertical
  })), /*#__PURE__*/react_default.a.createElement(Products_ProductList, {
    allVariants: allVariants,
    products: sortedProducts,
    regionId: regionId,
    countryId: countryId.toLowerCase()
  }), /*#__PURE__*/react_default.a.createElement(Products_Reviews, {
    productHandle: "soundboks-gen-2"
  }));
};

/* harmony default export */ var pages_Products = (Products_Products);
// EXTERNAL MODULE: ./components/shared/Meta/index.js + 6 modules
var Meta = __webpack_require__("ACIN");

// EXTERNAL MODULE: ./components/shared/AdditionalScripts/TrustedShop/index.js + 1 modules
var TrustedShop = __webpack_require__("5zck");

// EXTERNAL MODULE: ./containers/summer-campaign/index.tsx + 3 modules
var summer_campaign = __webpack_require__("Qiyr");

// CONCATENATED MODULE: ./pages/products/index.tsx
var products_jsx = react_default.a.createElement;






 // ProductPage

var products_ProductsPage = function ProductsPage() {
  var _useCheckRegion = Object(useCheckRegion["a" /* default */])(),
      isROEU = _useCheckRegion.isROEU;

  var pageInfo = {
    title: isROEU ?
    /*i18n*/
    {
      id: "products.meta.title.eu"
    } :
    /*i18n*/
    {
      id: "products.meta.title"
    },
    desc:
    /*i18n*/
    {
      id: "products.meta.description"
    },
    url: '/products'
  };
  return /*#__PURE__*/react_default.a.createElement(Layout["a" /* default */], null, /*#__PURE__*/react_default.a.createElement(Meta["a" /* default */], {
    pageInfo: pageInfo
  }), /*#__PURE__*/react_default.a.createElement(summer_campaign["a" /* default */], null), /*#__PURE__*/react_default.a.createElement(pages_Products, null), /*#__PURE__*/react_default.a.createElement(TrustedShop["a" /* default */], null));
};

/* harmony default export */ var pages_products = __webpack_exports__["default"] = (products_ProductsPage);

/***/ }),

/***/ "o0o1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("ls82");


/***/ })

},[["FZPq",0,1,2,3,4,5,6,7,8,12,11,13,20,24]]]);